import { useMap } from '@vis.gl/react-google-maps'
import { useEffect } from 'react'

export interface UseMapEventsProps {
  onDragStart?: () => void
  onZoomChanged?: () => void
  onCenterChanged?: (center: google.maps.LatLng | undefined) => void
}

export const useMapEvents = ({
  onCenterChanged,
  onDragStart,
  onZoomChanged,
}: UseMapEventsProps) => {
  const map = useMap()

  useEffect(() => {
    if (!map) return () => undefined
    const dragStartListener = google.maps.event.addListener(map, 'dragstart', () => {
      if (onDragStart) onDragStart()
    })

    const zoomChangedListener = google.maps.event.addListener(map, 'zoom_changed', () => {
      if (onZoomChanged) onZoomChanged()
    })

    const centerChangedListener = google.maps.event.addListener(map, 'center_changed', () => {
      const center = map.getCenter()
      if (center && onCenterChanged) {
        onCenterChanged(center)
      }
    })

    return () => {
      google.maps.event.removeListener(dragStartListener)
      google.maps.event.removeListener(centerChangedListener)
      google.maps.event.removeListener(zoomChangedListener)
    }
  }, [map, onCenterChanged, onDragStart, onZoomChanged])
}
